import { render, staticRenderFns } from "./transaksi_now.vue?vue&type=template&id=66f8dd46&scoped=true&"
import script from "./transaksi_now.vue?vue&type=script&lang=js&"
export * from "./transaksi_now.vue?vue&type=script&lang=js&"
import style0 from "./transaksi_now.vue?vue&type=style&index=0&id=66f8dd46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f8dd46",
  null
  
)

export default component.exports